import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import DictionaryForm from "@/components/dictionaries/DictionaryForm";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import PageContent from "@/components/PageContent";
import { Input } from "@/components/ui/input";
import { isRequired } from "@/lib/form";
import { useDepartmentsDictionary } from "@/modules/departments/hooks/useDepartmentsDictionary";
import { useTranslation } from "react-i18next";
import SaveButton from "@/components/SaveButton";

export default function DepartmentForm() {
  const { t } = useTranslation();
  const config = useDepartmentsDictionary();
  const { Icon, ns } = config;
  const labels = config.getLabels(t);
  const { mutation } = useDictionaryContext();

  return (
    <DictionaryForm>
      <PageContent
        icon={<Icon className="w-6 h-6 mr-3" />}
        title={labels.title}
        footer={<SaveButton />}
      >
        <Fieldset className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Field
            name="name"
            label={t(`${ns}.fields.name`)}
            required={isRequired(config.schema.shape.name)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
          <Field
            name="description"
            label={t(`${ns}.fields.description`)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
        </Fieldset>
      </PageContent>
    </DictionaryForm>
  );
}
